/* global archiuiApp, ENDPOINT_COMPONENT */
var angular = require('angular');
angular.module('promemoria')
.component('auiDeepsearch', {
  template: require('./deepsearch.html'),
  bindings: {    
    keywords: '=',
    filtri: '=',
    update: '&'
  },

  controller: function ($scope, $element, $attrs, $http, ENDPOINT_AGGREGATE) {
    var ctrl = this;    
    this.fondi = [];
    this.activeFilter = {};
    this.label = "";

    ctrl.$onInit = function ()  {
      ctrl.handlePlaceholder();           
    };

    ctrl.handlePlaceholder = function(){
      ctrl.placeholder = "Inizia la tua ricerca...";
      if(!_.isEmpty(ctrl.keywords) && ctrl.keywords.length > 0){
        ctrl.placeholder = "Continua la tua ricerca...";
      }       
    };

    ctrl.selezionaKeyword = function(tag) {
      if(!_.isEmpty(ctrl.activeFilter)){

        //first add the filter and call the update
        _.remove(ctrl.filtri, function(o) {
          if(typeof o.data !== "undefined"){
            return o.data.path.startsWith('/Superfondo di appartenenza');
          }            
        });

        ctrl.filtri.push(ctrl.activeFilter);
      }
      ctrl.handlePlaceholder();           
      ctrl.update();
    };

    ctrl.removeTag = function(){
      _.remove(ctrl.keywords);      
      ctrl.handlePlaceholder();           
      ctrl.update();
    };
  }
});



// WEBPACK FOOTER //
// ./src/js/components/deepsearch/deepsearch.js